/*
 * Cart-add for bundle / tool cards — Add to Cart + GA4 select_promotion.
 * Binds every [data-cart-add-form] on the page: the recipe-page bundle card
 * and the blog-article tool block. Promotion name/slot are read from the
 * button's data-creative-* attributes, falling back to the recipe defaults
 * so the recipe page keeps its original analytics with no markup change.
 */
(function () {
  'use strict';

  function init() {
    var forms = document.querySelectorAll('[data-cart-add-form]');
    for (var i = 0; i < forms.length; i++) {
      bindForm(forms[i]);
    }
  }

  function bindForm(form) {
    var btn = form.querySelector('[data-bundle-cta]');
    if (!btn) return;

    var originalLabel = btn.textContent;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      fireSelectPromotion(btn);

      btn.disabled = true;
      btn.textContent = 'Adding…';

      var data = new FormData(form);
      fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: data })
        .then(function (res) {
          if (!res.ok) throw new Error('cart-add failed: ' + res.status);
          return res.json();
        })
        .then(function (item) {
          fireAddToCart(btn, item);
          btn.textContent = 'Added';
          if (window.AurumAsh && window.AurumAsh.cart) {
            window.AurumAsh.cart.refresh();
            window.AurumAsh.cart.open();
          }
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = originalLabel;
          }, 1500);
        })
        .catch(function (err) {
          console.error('[bundle-cta]', err);
          btn.disabled = false;
          btn.textContent = originalLabel;
        });
    });
  }

  function fireSelectPromotion(btn) {
    if (!window.gtag) return;
    var params = {
      creative_name: btn.dataset.creativeName || 'recipe_bundle_cta',
      creative_slot: btn.dataset.creativeSlot || 'recipe_tools_area',
      promotion_id: btn.dataset.promotionId,
      promotion_name: btn.dataset.promotionName,
      item_id: btn.dataset.variantId
    };
    if (btn.dataset.recipeHandle) params.recipe_handle = btn.dataset.recipeHandle;
    if (btn.dataset.recipeMethod) params.recipe_method = btn.dataset.recipeMethod;
    window.gtag('event', 'select_promotion', params);
  }

  // Fired on a confirmed add. `item` is the /cart/add.js line-item response:
  // { id (variant id), product_title, quantity, price (cents), line_price (cents) }.
  function fireAddToCart(btn, item) {
    if (!item || typeof item !== 'object') return;
    var currency = (window.Shopify && window.Shopify.currency &&
                    window.Shopify.currency.active) || 'USD';
    var qty = item.quantity || 1;
    var unit = (item.price || 0) / 100;
    var lineValue = (item.line_price != null ? item.line_price : (item.price || 0) * qty) / 100;
    var variantId = String(item.id || btn.dataset.variantId || '');
    var name = item.product_title || btn.dataset.promotionName;

    if (window.gtag) {
      var gaParams = {
        currency: currency,
        value: lineValue,
        items: [{
          item_id: variantId,
          item_name: name,
          quantity: qty,
          price: unit
        }],
        promotion_id: btn.dataset.promotionId
      };
      if (btn.dataset.recipeHandle) gaParams.recipe_handle = btn.dataset.recipeHandle;
      if (btn.dataset.recipeMethod) gaParams.recipe_method = btn.dataset.recipeMethod;
      window.gtag('event', 'add_to_cart', gaParams);
    }

    if (window.Shopify && window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish('aurum_ash:bundle_added', {
        variantId: variantId,
        productTitle: name,
        value: lineValue,
        currency: currency,
        recipeHandle: btn.dataset.recipeHandle,
        recipeMethod: btn.dataset.recipeMethod,
        promotionId: btn.dataset.promotionId
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
